import React from 'react'
import AssignmentMenuItemListContainer from './AssignmentMenuItemListContainer'
import AppBar from '../../components/AppBar'

export default () => {
  return (
    <div className="pt-20 px-4 md:px-8 w-full">
      <AppBar header="Assignment" hasBtnGroup />
      <div className="py-8 max-w-7xl mx-auto">
        <AssignmentMenuItemListContainer />
      </div>
    </div>
  )
}
